import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '代理店管理',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: true,
  staffOnly: true,
  order: 4,
  rolesOnly: ['admin', 'FCJapan'],
};
